import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDirection
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Receives a network point to display EXIT and/or ENTRY labels as required.
     *
     * @param {Object} networkPoint `NetworkPointDto`
     * @param {boolean?} [entry=false] show or hide entry direction explicitly
     * @param {boolean?} [exit=false] show or hide exit direction explicitly
     * @param {boolean?} [bundle=false] show or hide bundle direction explicitly
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpDirection', pkpDirection);

    function pkpDirection(platformSettingsService) {
        return {
            restrict: 'E',
            scope: {
                networkPoint: '=',
                entry: '=?',
                exit: '=?',
                bundle: '=?'
            },
            template: require('app/_directives/pkp-direction.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DIRECTION = platformSettingsService.DIRECTION;
            scope.entry = scope.entry === true;
            scope.exit = scope.exit === true;
            scope.bundle = scope.bundle === true;
        }
    }
})();
